import { config } from '#config/configuration';
import { configureDayjs } from '#helpers';
import { i18next } from '#i18n';
import App from '#root/App.vue';
import router from '#router';
import { piniaStore } from '#stores/createPinia';
import { Uuid } from '@c4-links/vue3-links-components';
import { DataTablePlugin } from '@c4-links/vue3-links-components/data-table';
import VueGtm from '@gtm-support/vue-gtm';
import { VueQueryPlugin } from '@tanstack/vue-query';
import i18nextVue from 'i18next-vue';
import { createApp } from 'vue';
import CountryFlag from 'vue-country-flag-next';
import VueFeather from 'vue-feather';

import '@c4-links/vue3-links-components/style.css';
import './styles/main.css';

configureDayjs();
const app = createApp(App);

const gtmEnabled = config.gtm.enabled && config.gtm.id && config.gtm.id !== 'GTM-XXXXXXX';

if (gtmEnabled) {
  app.use(VueGtm, {
    id: config.gtm.id,
    enabled: true,
    debug: config.devMode,
    // Managing envs
    queryParams: {
      gtm_auth: config.gtm.auth,
      gtm_preview: config.gtm.preview,
      gtm_cookies_win: 'x'
    }
    // We don't use vue-router integration to avoid tracking query changes
  });
} else {
  console.info('GTM is disabled or not configured');
}

app.use(DataTablePlugin);
app.use(Uuid);
app.use(piniaStore);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        throwOnError: true,
        staleTime: 1000 * 60 * 60 * 6, //refetch until 6 hours
        gcTime: 1000 * 60 * 60 * 6 // cache for 6 hours
      }
    }
  }
});
app.use(router);

app.component(VueFeather.name ?? 'VueFeather', VueFeather);
app.component('CountryFlag', CountryFlag);
app.use(i18nextVue, { i18next });

app.mount('#app');
